import { render, staticRenderFns } from "./HandeCopy.vue?vue&type=template&id=276529ac&scoped=true"
import script from "./HandeCopy.vue?vue&type=script&lang=js"
export * from "./HandeCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276529ac",
  null
  
)

export default component.exports